require('../../modules/es6.object.set-prototype-of');
module.exports = require('../../modules/_core').Object.setPrototypeOf;



//////////////////
// WEBPACK FOOTER
// ./~/@babel/runtime-corejs2/~/core-js/library/fn/object/set-prototype-of.js
// module id = 406
// module chunks = 4